import React, { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { Switch } from "./ui/switch";
import { useToast } from "../hooks/use-toast";
import { api } from "../lib/api";

/**
 * Org-wide MFA policy toggle. Forcing MFA for specific individuals is done
 * per-row in Users & scopes instead (gives a 7-day grace period either way).
 */
export default function MfaAdminSettings() {
  const { toast } = useToast();
  const [requiredGlobally, setRequiredGlobally] = useState(false);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/mfa/settings").then((r) => setRequiredGlobally(r.data.required_globally)).finally(() => setLoading(false));
  }, []);

  const toggle = async (v) => {
    setBusy(true);
    setRequiredGlobally(v);
    try {
      await api.post("/admin/mfa/settings", { required_globally: v });
      toast({ title: v ? "MFA now required for everyone" : "MFA no longer required org-wide" });
    } catch (e) {
      setRequiredGlobally(!v);
      toast({ title: "Couldn't update", description: e?.response?.data?.detail, variant: "destructive" });
    } finally { setBusy(false); }
  };

  if (loading) return <div className="h-14 rounded-lg bg-muted/40 animate-pulse" />;

  return (
    <div className="flex items-center justify-between rounded-lg border border-border p-3" data-testid="mfa-global-toggle-row">
      <div className="flex items-center gap-3">
        <ShieldAlert className="w-5 h-5 text-muted-foreground" />
        <div>
          <div className="font-medium">Require MFA for all users</div>
          <div className="text-[12.5px] text-muted-foreground">Everyone gets a 7-day grace period to set up a passkey or authenticator app before being blocked.</div>
        </div>
      </div>
      <Switch data-testid="mfa-global-toggle-switch" checked={requiredGlobally} onCheckedChange={toggle} disabled={busy} />
    </div>
  );
}
